import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, Icon } from 'omni-common-ui';
import styles from './style.postcss';

const SubmitSuccessDialog = ({
  isOpen,
  groupName,
  onCloseClick,
}) => (
  <Dialog
    isOpen={isOpen}
    className={styles.SubmitSuccessDialog_card}
    onRequestClose={() => onCloseClick()}
  >
    <div className={styles.SubmitSuccessDialog}>
      <div className={styles.SubmitSuccessDialog_header}>
        <Icon id="success" className={styles.SubmitSuccessDialog_icon} />
        <div className={styles.SubmitSuccessDialog_title}>
          Done
        </div>
      </div>
      <p className={styles.SubmitSuccessDialog_groupName}>
        {groupName}
      </p>
      <p className={styles.SubmitSuccessDialog_message}>
        Progress Report is submitted.
      </p>
      <Button.Container className={styles.SubmitSuccessDialog_buttons}>
        <Button
          type={Button.Type.primary}
          className={styles.SubmitSuccessDialog_button}
          onClick={() => onCloseClick()}
        >
          Close
        </Button>
      </Button.Container>
    </div>
  </Dialog>
);

SubmitSuccessDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  groupName: PropTypes.string,
  onCloseClick: PropTypes.func.isRequired,
};

export default SubmitSuccessDialog;



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/SubmitSuccessDialog/index.jsx